import { useState } from "react";
import { ChevronLeft, Check, Loader, ShieldCheck } from "lucide-react";
import { C, SELFTEST_STEPS, SELFTEST_LOG } from "./data";
import { Serif, Label } from "./ui";

export default function SelfTest({ nav }) {
  const [phase, setPhase] = useState("idle"); // idle | running | done
  const [step, setStep] = useState(-1);

  const run = () => {
    setPhase("running"); setStep(0);
    let i = 0;
    const id = setInterval(() => {
      i += 1;
      if (i >= SELFTEST_STEPS.length) { clearInterval(id); setStep(SELFTEST_STEPS.length); setPhase("done"); }
      else setStep(i);
    }, 850);
  };

  return (
    <div style={{ padding: "24px 22px 30px" }} data-testid="consumer-selftest">
      <button onClick={() => nav("home")} data-testid="selftest-back" style={{ display: "inline-flex", alignItems: "center", gap: 5, background: "none", border: 0, color: C.slate, fontSize: 13, cursor: "pointer", marginBottom: 18 }}>
        <ChevronLeft size={16} /> Home
      </button>
      <Label>Self-test routine</Label>
      <Serif size={26} style={{ margin: "5px 0 4px" }}>Check your <em style={{ color: C.slate }}>safety net</em>.</Serif>
      <div style={{ fontSize: 13, color: C.slate, marginBottom: 22, lineHeight: 1.5 }}>A safe, silent drill — no responders are dispatched. Takes about 15 seconds.</div>

      <div style={{ background: "#fff", border: "1px solid rgba(26,30,36,0.08)", borderRadius: 12, overflow: "hidden", marginBottom: 18 }}>
        {SELFTEST_STEPS.map((s, i) => {
          const done = i < step, active = i === step && phase === "running";
          return (
            <div key={s.t} style={{ display: "flex", gap: 12, padding: 14, borderTop: i ? "1px solid rgba(26,30,36,0.06)" : "none", opacity: phase === "idle" ? 0.85 : done || active ? 1 : 0.4 }} data-testid={`selftest-step-${i}`}>
              <div style={{ width: 24, height: 24, borderRadius: "50%", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", background: done ? C.green : active ? C.amber : "rgba(26,30,36,0.08)", color: done || active ? "#fff" : C.slate }}>
                {done ? <Check size={14} /> : active ? <Loader size={13} className="spin" /> : i + 1}
              </div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 600, color: C.ink }}>{s.t}</div>
                <div style={{ fontSize: 12, color: C.slate }}>{s.d}</div>
              </div>
            </div>
          );
        })}
      </div>
      <style>{`.spin{animation:spin 1s linear infinite}@keyframes spin{to{transform:rotate(360deg)}}`}</style>

      {phase === "done" ? (
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: 15, background: `${C.green}14`, border: `1px solid ${C.green}44`, borderRadius: 12, color: C.green, fontWeight: 600, fontSize: 14, marginBottom: 18 }} data-testid="selftest-result">
          <ShieldCheck size={18} /> All systems nominal · you're protected
        </div>
      ) : (
        <button onClick={run} disabled={phase === "running"} data-testid="selftest-run"
          style={{ width: "100%", padding: 15, background: phase === "running" ? C.slate : C.red, color: "#fff", border: 0, borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: phase === "running" ? "default" : "pointer", marginBottom: 22 }}>
          {phase === "running" ? "Running self-test…" : "Run self-test"}
        </button>
      )}

      <Label style={{ marginBottom: 10 }}>Recent tests</Label>
      {SELFTEST_LOG.map((l, i) => (
        <div key={l.date} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "11px 13px", background: "#fff", border: "1px solid rgba(26,30,36,0.07)", borderRadius: 9, marginBottom: 6 }}>
          <span style={{ fontSize: 12, color: C.slate, fontFamily: "'JetBrains Mono', monospace" }}>{l.date}</span>
          <span style={{ fontSize: 11, fontWeight: 700, color: l.result === "pass" ? C.green : C.amber, textTransform: "uppercase" }}>{l.result === "pass" ? "Pass" : "Check"}</span>
        </div>
      ))}
    </div>
  );
}
